import { Search } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { type IntegracoesInfo } from './Types';
import Input from '../../ui/Input';
import { RadioGroup, RadioGroupItem } from '../../ui/RadioGroup/RadioGroup';
import { useTranslation } from '../../lib/i18n/TranslationContext';

const NavIntegracao = ({ integracoesInfo, onValueChange, onInstallChange, onInputChange }: IntegracoesInfo) => {
	const appTags = Array.from(new Set(integracoesInfo.flatMap((item) => item.tags || [])));
	const hasEmpreenderApps = integracoesInfo.some((item) => item.appEmpreender);
	const { t } = useTranslation();

	const [installFilter, setInstallFilter] = useState('all');
	const [categoryFilter, setCategoryFilter] = useState('*');

	useEffect(() => {
		if (!hasEmpreenderApps && installFilter === 'empreender') {
			setInstallFilter('all');
			onInstallChange?.('all');
		}
	}, [hasEmpreenderApps, installFilter, onInstallChange]);

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		onInputChange?.(value);

		setInstallFilter('all');
		setCategoryFilter('*');
		onInstallChange?.('all');
		onValueChange?.('*');
	};

	return (
		<div className='flex w-full shrink-0 flex-col gap-6 self-start bg-white md:sticky md:top-10 md:z-10 md:max-h-[calc(100dvh-7.5rem)] md:w-56 md:overflow-y-auto md:before:pointer-events-none md:before:absolute md:before:inset-x-0 md:before:bottom-full md:before:h-10 md:before:bg-white'>
			<div className='grid grid-cols-1'>
				<Input
					onChange={handleInputChange}
					placeholder={t('Pesquisar...')}
					className='col-start-1 row-start-1 !px-3 !py-2 !pl-10 placeholder:text-gray-400'
				/>
				<Search aria-hidden='true' className='pointer-events-none col-start-1 row-start-1 ml-3 size-4 self-center text-gray-400' />
			</div>

			<div className='flex flex-col gap-2'>
				<h3 className='text-sm font-medium leading-6 text-gray-900'>{t('Exibir')}</h3>
				<RadioGroup
					value={installFilter}
					className='[&_label]:!font-normal [&_label]:!text-muted-foreground [&_[data-state=checked]+label]:!font-medium [&_[data-state=checked]+label]:!text-gray-900'
					onValueChange={(e) => {
						setInstallFilter(e);
						onInstallChange?.(e);
					}}>
					<RadioGroupItem value='all' id='option-all' label={t('Todos')} />
					{hasEmpreenderApps && (
						<RadioGroupItem value='empreender' id='option-empreender' label={t('Aplicativos Empreender')} />
					)}
					<RadioGroupItem value='installed' id='option-installed' label={t('Conectados')} />
					<RadioGroupItem value='not-installed' id='option-not-installed' label={t('Não conectados')} />
				</RadioGroup>
			</div>

			{appTags.length > 0 && (
				<div className='flex flex-col gap-2'>
					<h3 className='text-sm font-medium leading-6 text-gray-900'>{t('Categorias')}</h3>
					<RadioGroup
						value={categoryFilter}
						className='[&_label]:!font-normal [&_label]:!text-muted-foreground [&_[data-state=checked]+label]:!font-medium [&_[data-state=checked]+label]:!text-gray-900'
						onValueChange={(e) => {
							setCategoryFilter(e);
							onValueChange?.(e);
						}}>
						<RadioGroupItem value='*' id='all' label={t('Todas as categorias')} />
						{appTags.map((tag) => (
							<RadioGroupItem key={tag} value={tag} id={tag} label={tag} />
						))}
					</RadioGroup>
				</div>
			)}
		</div>
	);
};

export default NavIntegracao;
